
define('tpl!taoQtiItem/qtiXmlRenderer/tpl/responses/map_response', ['handlebars'], function(hb){ 
return hb.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, functionType="function", escapeExpression=this.escapeExpression;


  buffer += "<responseCondition>\n    <responseIf>\n        <not>\n            <isNull>\n                <variable identifier=\"";
  if (helper = helpers.responseIdentifier) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.responseIdentifier); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" />\n            </isNull>\n        </not>\n        <setOutcomeValue identifier=\"";
  if (helper = helpers.outcomeIdentifier) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.outcomeIdentifier); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\">\n            <sum>\n                <variable identifier=\"";
  if (helper = helpers.outcomeIdentifier) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.outcomeIdentifier); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" />\n                <mapResponse identifier=\"";
  if (helper = helpers.responseIdentifier) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.responseIdentifier); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" />\n            </sum>\n        </setOutcomeValue>\n    </responseIf>\n</responseCondition>";
  return buffer;
  });
});

